import I18n from "common/i18n";
import { btnDelay, usePlaySound } from "common/utils";
import { PillSize, PillColor, BuilderPillButton } from "./BuilderPillButton";

// 追加カードが画面外のときに右下へ表示する FAB。押下で最下部へスクロールする補助動線。
export const AddMapButton = ({ onClick }: { onClick: () => void }) => {
  const play = usePlaySound();

  const handleClick = () => {
    play();
    btnDelay(() => onClick());
  };

  return (
    <div className="absolute bottom-4 right-6 z-20 pointer-events-auto">
      <BuilderPillButton
        color={PillColor.BLUE}
        size={PillSize.MD}
        icon="arrow_downward"
        ariaLabel={I18n.t("MSG_BUILDER_SCROLL_TO_BOTTOM_BTN")}
        onClick={handleClick}
      />
    </div>
  );
};
